import { useMutation, useQueryClient } from "react-query";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";

export const useUpdateLeagueStatus = () => {
  const { getAccessTokenSilently } = useAuth0();
  const apiUrl = process.env.REACT_APP_API_URL;
  const queryClient = useQueryClient(); // Initialize queryClient for query invalidation

  return useMutation(
    async ({ leagueId, status }) => {
      const token = await getAccessTokenSilently();

      const response = await axios.put(
        `${apiUrl}/api/league/${leagueId}/update-status`, // Ensure this URL matches your backend route
        { status },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    },
    {
      onSuccess: (data, variables) => {
        // Handle successful update and invalidate the leagueDetails query

        // Invalidate the leagueDetails query to refetch updated data
        queryClient.invalidateQueries(["leagueDetails", variables.leagueId]);
      },
      onError: (error) => {
        // Log or display error message
        console.error(
          "Error updating league status:",
          error.response ? error.response.data : error
        );
      },
    }
  );
};
